var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas"},[_c('canvas',{staticStyle:{"width":"177px","height":"177px"},attrs:{"id":_vm.id,"width":"190","height":"190"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }